module.exports = __webpack_public_path__ + "img/38754-049.138c0b22.jpg";